export default (props, e) => {
	dataLayer.push({
		'event': props.event,
		'fgVarCat': props.fgVarCat,
		'fgVarAct': props.fgVarAct,
		'fgVarLbl': props.fgVarLbl
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/pushDataLayer.js